<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.666016 9.0013C0.666016 4.3988 4.39685 0.667969 8.99935 0.667969C13.6018 0.667969 17.3327 4.3988 17.3327 9.0013C17.3327 13.6038 13.6018 17.3346 8.99935 17.3346C4.39685 17.3346 0.666016 13.6038 0.666016 9.0013ZM8.99935 2.33464C7.23124 2.33464 5.53555 3.03701 4.2853 4.28726C3.03506 5.5375 2.33268 7.23319 2.33268 9.0013C2.33268 10.7694 3.03506 12.4651 4.2853 13.7153C5.53555 14.9656 7.23124 15.668 8.99935 15.668C10.7675 15.668 12.4632 14.9656 13.7134 13.7153C14.9636 12.4651 15.666 10.7694 15.666 9.0013C15.666 7.23319 14.9636 5.5375 13.7134 4.28726C12.4632 3.03701 10.7675 2.33464 8.99935 2.33464Z"
      fill="#213E7A"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.83333 4.83333C9.83333 4.61232 9.74554 4.40036 9.58926 4.24408C9.43297 4.0878 9.22101 4 9 4C8.77899 4 8.56702 4.0878 8.41074 4.24408C8.25446 4.40036 8.16667 4.61232 8.16667 4.83333V8.16667H4.83333C4.61232 8.16667 4.40036 8.25446 4.24408 8.41074C4.0878 8.56702 4 8.77899 4 9C4 9.22101 4.0878 9.43297 4.24408 9.58926C4.40036 9.74554 4.61232 9.83333 4.83333 9.83333H8.16667V13.1667C8.16667 13.3877 8.25446 13.5996 8.41074 13.7559C8.56702 13.9122 8.77899 14 9 14C9.22101 14 9.43297 13.9122 9.58926 13.7559C9.74554 13.5996 9.83333 13.3877 9.83333 13.1667V9.83333H13.1667C13.3877 9.83333 13.5996 9.74554 13.7559 9.58926C13.9122 9.43297 14 9.22101 14 9C14 8.77899 13.9122 8.56702 13.7559 8.41074C13.5996 8.25446 13.3877 8.16667 13.1667 8.16667H9.83333V4.83333Z"
      fill="#213E7A"
    />
  </svg>
</template>

<script>
export default {
  name: "IconCircleAdd",
};
</script>
